// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { Duration } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import type Enums from '../Enums';
import { NewPlant, Plant, type PlantWireFormat } from '../Plant/Plant';

export class ProjectPlant {
  readonly plant: Plant;
  readonly plantDistance: string | null;
  readonly plantDistanceUnit: Enums.Unit | null;
  readonly plantDriveTime: Duration | null;

  constructor(data: { [key: string]: any } = {}) {
    this.plant = NewPlant(data.plant);
    this.plantDistance = data.plantDistance === undefined ? null : data.plantDistance;
    this.plantDistanceUnit = data.plantDistanceUnit === undefined ? null : data.plantDistanceUnit;
    this.plantDriveTime = DateHelpers.ParseServerNullableDuration(data.plantDriveTime);
  }

  static zero(): ProjectPlant {
    const zeroValues: ExcludeMethodsDeep<ProjectPlant> = {
      plant: Plant.zero(),
      plantDistance: null,
      plantDistanceUnit: null,
      plantDriveTime: null,
    };
    return new ProjectPlant(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectPlantWireFormat = {
  plant: PlantWireFormat;
  plantDistance: string | null;
  plantDistanceUnit: string | null;
  plantDriveTime: string | null;
};

type NewProjectPlantProps = PartialDeep<ProjectPlant, { recurseIntoArrays: true }>;
export const NewProjectPlant: (props: NewProjectPlantProps) => ProjectPlant = (props) =>
  new ProjectPlant(props);

type NewProjectPlantFromWireFormatProps = PartialDeep<
  ProjectPlantWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectPlantFromWireFormat: (
  props: NewProjectPlantFromWireFormatProps,
) => ProjectPlant = (props) => new ProjectPlant(props);
